// extracted by mini-css-extract-plugin
module.exports = {"root":"form-control-label_root__xAi4z","required":"form-control-label_required__JGQsA"};